import CascaderPanel from './cascader-panel';

export default CascaderPanel;
